import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}],["path",{"d":"M12 16v.01","key":"svg-1"}],["path",{"d":"M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483","key":"svg-2"}]]

const IconDeviceUnknown = createReactComponent('outline', 'device-unknown', 'DeviceUnknown', __iconNode);

export default IconDeviceUnknown;